import { useEffect, useRef, useState } from 'react';
import { Form, Input, Button, Upload, Typography, Row, Col, message, Card } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { InboxOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Service } from './service';
import './style.scss';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import { default as checkIcon } from '../../_config/images/check-magistal.png';
import InputRut from '../../components/Commons/InputCountry/Rut';
import LoadingPage from '../../v2-components/LoadingPage';
import { VALIDATION } from '../../v2-config/constants/validations.constant';

const { Text } = Typography;
const { Dragger } = Upload;

export const MagistralFormula = () => {
	const [form] = Form.useForm();
	const [fileList, setFileList] = useState([]);
	const [previews, setPreviews] = useState({});
	const [activeUid, setActiveUid] = useState(null);
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [requestNumber, setRequestNumber] = useState(null);
	const [loading, setLoading] = useState(false);
	const [infoPharmacy, setInfoPharmacy] = useState(null);
	const [isAddress] = useState(JSON.parse(localStorage.getItem('locationStore')));
	
	const history = useHistory();
	const location = useLocation();
	const service = new Service();
	const hiddenInputRef = useRef(null);

	const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
	const acceptAttr = '.jpg,.jpeg,.png,.pdf';
	const maxCount = 10;
	const maxSizeMB = 20;

	const addFiles = (files) => {
		const incoming = Array.from(files);
		if (fileList.length + incoming.length > maxCount) {
			message.error(`Máximo ${maxCount} archivos`);
			return;
		}
		const toAdd = [];
		const newPreviews = {};
		for (const file of incoming) {
			if (!validTypes.includes(file.type)) {
				message.error('Solo se permiten archivos JPG, JPEG, PNG o PDF');
				continue;
			}
			if (file.size / 1024 / 1024 >= maxSizeMB) {
				message.error('Cada archivo debe ser menor a 20 MB');
				continue;
			}
			const uid = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
			const url = URL.createObjectURL(file);
			newPreviews[uid] = { url, type: file.type, name: file.name };
			toAdd.push({
				uid,
				name: file.name,
				type: file.type,
				size: file.size,
				originFileObj: file,
			});
		}
		if (toAdd.length === 0) return;
		setPreviews((prev) => ({ ...prev, ...newPreviews }));
		setFileList((prev) => {
			const merged = [...prev, ...toAdd];
			if (!activeUid && merged.length > 0) setActiveUid(merged[0].uid);
			return merged;
		});
	};

	const uploadProps = {
		name: 'files',
		multiple: true,
		maxCount,
		accept: acceptAttr,
		fileList,
		showUploadList: false,
		beforeUpload: (file) => {
			addFiles([file]);
			return false;
		},
	};

	const handleSelect = (uid) => setActiveUid(uid);

	const handleRemove = (file) => {
		setFileList((prev) => {
			const next = prev.filter((f) => f.uid !== file.uid);
			if (activeUid === file.uid) setActiveUid(next[0]?.uid ?? null);
			return next;
		});
		const p = previews[file.uid];
		if (p?.url) URL.revokeObjectURL(p.url);
		setPreviews((prev) => {
			const { [file.uid]: _, ...rest } = prev;
			return rest;
		});
		message.info(`Archivo ${file.name} eliminado`);
	};

	useEffect(() => {
		new Service()
			.getPharmacy()
			.then((response) => {
				if (response?.data[0]) {
					setInfoPharmacy(response.data[0]);
					setLoading(false);
				}
			})
			.catch(() => {});
		return () => {
			Object.values(previews).forEach((p) => {
				if (p?.url) URL.revokeObjectURL(p.url);
			});
		};
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (location.state && location.state.reset) {
			setShowConfirmation(false);
			setRequestNumber(null);
			form.resetFields();
			fileList.forEach((f) => {
				const p = previews[f.uid];
				if (p?.url) URL.revokeObjectURL(p.url);
			});
			setFileList([]);
			setPreviews({});
			setActiveUid(null);
			history.replace({ pathname: location.pathname, search: location.search });
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.state]);

	const onFinish = async (values) => {
		if (fileList.length === 0) {
			message.error('Debe cargar al menos una receta válida');
			return;
		}
		setLoading(true);
		console.log('infoPharmacy', infoPharmacy);
		try {
			const files = fileList.map((f) => f.originFileObj || f);
			const uploadResponses = await Promise.all(files.map((file) => service.uploadRecipe(file)));
			const recipePaths = uploadResponses.map((r) => r?.files?.[0]?.file_path).filter(Boolean);
			console.log('recipePaths', recipePaths);
			if (recipePaths.length === 0) throw new Error('No se obtuvieron URLs válidas');
			const [first, ...rest] = values.fullName.trim().split(' ');
			const payload = {
				user_info: {
					first_name: first || '',
					last_name: rest.join(' ') || '',
					email: values.email,
					phone: values.phone,
					rut: values.rut,
					location: {
						lat: isAddress?.lat || '',
						lng: isAddress?.lng || '',
						address: isAddress?.address || '',
						street: isAddress?.street || '',
						commune: isAddress?.commune || '',
						region: isAddress?.region || '',
					},
				},
				quotation_type: 'magistral',
				pharmacy: Enviroment.ROOT_PHARMACY,
				recipe: recipePaths.length === 1 ? recipePaths[0] : recipePaths,
				// item_products: [{ id_pharol: '123', quantity: 1 }],
				country: Enviroment.COUNTRY,
			};
			const quotationRes = await service.createMagistralQuotation(payload);
			if (quotationRes?.statusCode === 400 || quotationRes?.statusCode === 500) {
				throw new Error('Error creando la cotización');
			}
			const emailPayload = {
				pharmacy_short: infoPharmacy?.pharmacy,
				short_code: quotationRes?.short_code,
				contact_email: infoPharmacy?.email,
				pharmacy: infoPharmacy?.name_local,
				info: {
					email: payload.user_info.email,
					first_name: payload.user_info.first_name,
					last_name: payload.user_info.last_name,
					phone: payload.user_info.phone,
				},
			};
			const response = await service.sendQuotationRequestToPharmacies(emailPayload);
			setRequestNumber(quotationRes?.short_code || 'N/A');
			console.log('emailPayload', emailPayload);
			console.log('response', response);
			setShowConfirmation(true);
		} catch (err) {
			message.error(err?.response?.data?.message || 'Ocurrió un error al enviar la solicitud');
		} finally {
			setLoading(false);
		}
	};

	const handleBackToPharmacy = () => history.push('/');

	const handleVolver = () => {
		setShowConfirmation(false);
		setRequestNumber(null);
		form.resetFields();
		fileList.forEach((f) => {
			const p = previews[f.uid];
			if (p?.url) URL.revokeObjectURL(p.url);
		});
		setFileList([]);
		setPreviews({});
		setActiveUid(null);
		history.push('/');
	};

	if (loading) {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth', // o 'auto' si no quieres animación
		});
		return <LoadingPage />;
	}
	if (showConfirmation) {
		return (
			<div className="quote-request-container">
				<div className="header-section">
					<h2 style={{ marginBottom: '0' }}>Solicitud de cotización</h2>
					<Button type="link" onClick={handleBackToPharmacy} className="back-link">
						Volver a farmacia
					</Button>
				</div>
				<div className="confirmation-wrapper">
					<div className="confirmation-card">
						<div className="confirmation-content">
							<div>
								<img src={checkIcon} alt="Check" width={180} height={180} />
							</div>
							<div className="confirmation-text">
								<p className="confirmation-title">
									¡Gracias por tu solicitud <span className="request-number">{requestNumber}</span>!
								</p>
								<p className="contact-info">Te estaremos enviando un mail cuando la farmacia haya cotizado tu receta</p>
								<Button type="primary" size="large" onClick={handleVolver} className="volver-btn">
									Seguir navegando
								</Button>
								<Text className="contact-info">
									Revisa tu correo electrónico, verifica tus productos y número de solicitud. De no recibir el correo con tu solicitud, escríbenos a{' '}
									<a href="mailto:contacto@benestarx.com" className="contact-email">
										contacto@narma.cl
									</a>
								</Text>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="quote-request-container">
			<div className="header-section">
				<h2 style={{ marginBottom: '0', fontSize: '18px' }}>Solicitud de cotización</h2>
				<Button type="link" onClick={handleBackToPharmacy} className="back-link">
					Volver a farmacia
				</Button>
			</div>

			<div className="instruction-text">
				<Text>Carga tus datos para que podamos enviarte una lista de productos y así puedas concretar la compra</Text>
			</div>

			<Row gutter={24}>
				<Col xs={24} md={12}>
					<Card className="upload-section">
						<h2 className="section-title">Carga de receta válida</h2>
						<Text className="format-info">
							Formato: JPG, JPEG, PNG, PDF
							<br />
							Tamaño máximo: 20 MB
						</Text>

						<Dragger {...uploadProps} className="upload-dragger">
							{activeUid && previews[activeUid] ? (
								previews[activeUid].type === 'application/pdf' ? (
									<div style={{ textAlign: 'center', padding: '20px' }}>
										<FilePdfOutlined style={{ fontSize: 48, color: '#e74c3c' }} />
										<p>Archivo PDF cargado correctamente</p>
									</div>
								) : (
									<div className="image-preview">
										<img src={previews[activeUid].url} alt={previews[activeUid].name} className="preview-image" />
									</div>
								)
							) : (
								<p className="ant-upload-drag-icon">
									<InboxOutlined />
								</p>
							)}
						</Dragger>

						<input
							ref={hiddenInputRef}
							type="file"
							accept={acceptAttr}
							multiple
							style={{ display: 'none' }}
							onChange={(e) => {
								if (e.target.files?.length) addFiles(e.target.files);
								e.target.value = '';
							}}
						/>

						<div className="file-list" style={{ border: '1px solid #eee', borderRadius: 8, padding: 8, maxHeight: 300, overflow: 'auto', marginTop: 12 }}>
							{fileList.length === 0 ? (
								<Text type="secondary">Sin archivos cargados</Text>
							) : (
								fileList.map((f) => (
									<Row
										key={f.uid}
										align="middle"
										justify="space-between"
										className={`file-row ${activeUid === f.uid ? 'file-row-active' : ''}`}
										style={{ padding: '8px 0', paddingLeft: '8px' }}
									>
										<Col span={16}>
											<Button type="link" className="file-link" style={{ padding: 0 }} onClick={() => handleSelect(f.uid)}>
												{previews[f.uid]?.type === 'application/pdf' ? <FilePdfOutlined style={{ marginRight: 6 }} /> : null}
												<span className="file-name">{previews[f.uid]?.name || f.name}</span>
											</Button>
										</Col>
										<Col span={8} style={{ textAlign: 'right' }}>
											<Button type="text" danger onClick={() => handleRemove(f)}>
												Eliminar
											</Button>
										</Col>
									</Row>
								))
							)}
						</div>

						{fileList.length > 0 && (
							<div className="add-more-wrap">
								<Button type="link" className="add-more-link" onClick={() => hiddenInputRef.current?.click()}>
									Agregar otra receta a la cotización
								</Button>
							</div>
						)}
					</Card>
				</Col>

				<Col xs={24} md={12}>
					<Card className="form-section">
						<h2 className="section-title">Ingrese sus datos</h2>
						<Form form={form} layout="vertical" onFinish={onFinish} className="user-form" id="magistralForm">
							<Form.Item name="fullName" label="Nombre y apellido" rules={VALIDATION.full_name}>
								<Input placeholder="Ingresar nombre y apellido" className="form-input" />
							</Form.Item>
							<Form.Item name="phone" label="Teléfono" rules={VALIDATION.phone_number_international}>
							<Input placeholder="56912345678" className="form-input" />
							</Form.Item>
							<InputRut name="rut" label="RUT" />
							<Form.Item
								name="email"
								label="Correo electrónico"
								rules={[
									{ required: true, message: 'Por favor ingrese su correo electrónico' },
									{ type: 'email', message: 'Ingrese un correo electrónico válido' },
								]}
							>
								<Input placeholder="ejemplo@mail.com" className="form-input" />
							</Form.Item>
							<Form.Item
								name="confirmEmail"
								label="Repetir correo electrónico"
								dependencies={['email']}
								rules={[
									{ required: true, message: 'Por favor confirme su correo electrónico' },
									({ getFieldValue }) => ({
										validator(_, value) {
											if (!value || getFieldValue('email') === value) return Promise.resolve();
											return Promise.reject(new Error('Los correos electrónicos no coinciden'));
										},
									}),
								]}
							>
								<Input placeholder="ejemplo@mail.com" className="form-input" />
							</Form.Item>
						</Form>
					</Card>
				</Col>
			</Row>

			<Row justify="center" style={{ marginTop: '10px' }}>
				<Button type="primary" htmlType="submit" form="magistralForm" size="large" className="submit-btn" loading={loading} disabled={loading}>
					{loading ? 'Enviando...' : 'Enviar'}
				</Button>
			</Row>
		</div>
	);
};
